'use strict';

var isDefinedAndNotNull = require('../lang/is-defined-and-not-null');

/**
 * Trasforma il dato in input in una stringa
 * @param value
 * @returns {string}
 */
module.exports = function toString(value) {
    if (typeof value === 'undefined') {
        return '';
    }

    return JSON.stringify(value);
};
